<template>
  <div>
    <v-app>
      <v-main>
        <router-view />
      </v-main>
    </v-app>
  </div>
</template>

<script>
export default {
  components: {},
  mounted() {
   
  },
};
</script>
